import {
  CONTRIBUTION_STATUS_CANCELLED,
  CONTRIBUTION_STATUS_IN_DEBT_COLLECTION,
  CONTRIBUTION_STATUS_PAID,
  CONTRIBUTION_STATUS_RESERVED
} from "../../../app/constants/contributionCalendarStatus";
import type { ContributionCalendarRow } from "./personDetailTypes";
import { isContributionWaived } from "./personDetailUtils";
import { MIN_PAYABLE_AMOUNT } from "./personAmountThresholds";

const OPEN_ITEM_BOOKING_TOLERANCE = 0.005;

export function isContributionBookable(row: ContributionCalendarRow): boolean {
  return Math.abs(Number(row.amount ?? 0)) >= OPEN_ITEM_BOOKING_TOLERANCE;
}

export function isContributionSelectable(row: ContributionCalendarRow): boolean {
  return isContributionBookable(row)
    && !isContributionWaived(row)
    && Number(row.status || 0) !== CONTRIBUTION_STATUS_RESERVED
    && Number(row.status || 0) !== CONTRIBUTION_STATUS_IN_DEBT_COLLECTION
    && Number(row.status || 0) !== CONTRIBUTION_STATUS_PAID;
}

/**
 * Offene und teiloffene Beiträge, die noch nicht in einen SEPA-Lauf eingereicht wurden.
 */
export function isContributionOpenItemActionEligible(row: ContributionCalendarRow): boolean {
  return isContributionSelectable(row)
    && Boolean(row.openItemId)
    && Number(row.openAmount || 0) > MIN_PAYABLE_AMOUNT
    && Number(row.status || 0) !== CONTRIBUTION_STATUS_CANCELLED;
}

export function isContributionEditable(row: ContributionCalendarRow): boolean {
  const isFullyPaid = Number(row.status || 0) === CONTRIBUTION_STATUS_PAID
    || Number(row.openAmount ?? 0) <= MIN_PAYABLE_AMOUNT;
  return isContributionBookable(row)
    && !isFullyPaid
    && !isContributionWaived(row)
    && Number(row.status || 0) !== CONTRIBUTION_STATUS_RESERVED
    && Number(row.status || 0) !== CONTRIBUTION_STATUS_IN_DEBT_COLLECTION;
}
